import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //border: "2px solid #000",
    // boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "425px",
  },
}));

export default function TransitionsModal(props) {
  const classes = useStyles();
  let reload = true 
  const {
    workFlowExamMsg,
    setWorkFlowExamMsg,
    showFinishModal,
    onSubmit,
    result,
    showResult,
    showscore,
    queryResult,
    setResumeFlag
  } = props;
  const handleClose = async() => {
    await setResumeFlag(false) 
    window.onbeforeunload = (event) =>{
      event.preventDefault();
    }
    // onSubmit('010');
    // reload = false
    window.location.reload("/dashboard");    
    // props.history.push('/dashboard')
  };

  window.onbeforeunload = function (e) {
    e.preventDefault();
  }

  // useEffect(() => {
  //   if (reload) {
  //     const unloadCallback = (event) => {
  //       event.preventDefault();
  //       event.returnValue = "";
  //       return "";
  //     };
  //     window.addEventListener("beforeunload", unloadCallback);
  //     return () => window.removeEventListener("beforeunload", unloadCallback);
  //   }
  // }, []);
  return (
    <div>
      <Modal
        disableEnforceFocus = {true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={showFinishModal}
        //onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={showFinishModal}>
          {/* <div className={classes.paper}> */}
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            <div style={{ textAlign: "center" }}>
              <h3
                id="transition-modal-title"
                style={{ color: "#6f2981", marginBottom: "30px" }}
              >
                System Warning
              </h3>
            </div>
            {/* <p
              id="transition-modal-description"
              style={{ textAlign: "justify" }}
            >
              Your Test has been Submitted. Please attempt Pending Tests.
              <br />
              <br />
              Thanking you,
              <br />
              Support, AssessHub.
            </p> */}
            {showscore ? (
              result !== undefined && result !== null && showResult ? (
                <div className="form-group" style={{ textAlign: "center" }}>
                  <p
                    style={{ fontWeight: "bold" }}
                    dangerouslySetInnerHTML={{ __html: result }}
                  ></p>
                  <ul className="list-inline">
                    <li>
                      <a
                        className="btn btn-blue"
                        style={{ borderRadius: "10px" }}
                        onClick={() => handleClose()}
                      >
                        <strong>Close</strong>
                      </a>
                    </li>
                  </ul>
                </div>
              ) : (
                <>
                <p>
                <b>Your result is being processed.Please <b style={{color:"#8d0001"}}>DO NOT</b> refresh this page or close the browser.</b>
                </p>
                </>
              )
            ) : (
              <div className="form-group" style={{ textAlign: "center" }}>
                  {queryResult ? (
                    <>
                      <p>
                        <b>Your result is being processed.Please <b style={{ color: "#8d0001" }}>DO NOT</b> refresh this page or close the browser.</b>
                      </p>
                    </>
                  ) : (
                      <><p
                        id="transition-modal-description"
                        style={{ textAlign: "justify" }}
                      >{workFlowExamMsg !== '' ? workFlowExamMsg :
                        <> Your Test has been Submitted. Please attempt Pending Tests.</>
                        }
                          <br />
                          <br />
                          Thanking you,
                          <br />
                          Support, AssessHub. 
                      </p>
                      <ul className="list-inline">
                        <li>
                          <a
                            className="btn btn-blue"
                            style={{ borderRadius: "10px" }}
                            onClick={() => handleClose()}
                          >
                            <strong>Close</strong>
                          </a>
                        </li>
                      </ul></>
                  )}
              </div>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
